export type AssignmentType = 'NORMAL' | 'WEEK' | 'EXAM';

export type SubmissionStatus =
  | 'SUBMITTED'
  | 'REVIEWED'
  | 'NEEDS_REVISION'
  | 'APPROVED'
  | 'SUBMIT_LATER';

export const ASSIGNMENT_TYPE_LABELS: Record<AssignmentType, string> = {
  NORMAL: 'Thường',
  WEEK: 'Tuần',
  EXAM: 'Bài thi',
};

export const SUBMISSION_STATUS_LABELS: Record<SubmissionStatus, string> = {
  SUBMITTED: 'Đã nộp',
  REVIEWED: 'Đã chấm',
  NEEDS_REVISION: 'Cần chỉnh sửa',
  APPROVED: 'Đã duyệt',
  SUBMIT_LATER: 'Nộp muộn',
};

export interface AssignmentListItem {
  id: number;
  title: string | null;
  type: AssignmentType | null;
  dueDate: string | null;
  published: boolean;
  autoPublished: boolean | null;
  autoPublishAt: string | null;
  communityId: number | null;
  communityName: string | null;
  courseId: number | null;
  courseName: string | null;
  totalSubmissions: number;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface AssignmentDetail {
  id: number;
  title: string | null;
  description: string | null;
  type: AssignmentType | null;
  dueDate: string | null;
  gracePeriodMinutes: number | null;
  published: boolean;
  autoPublished: boolean | null;
  autoPublishAt: string | null;
  imageUrls: string[];
  pdfUrls: string[];
  videoUrls: string[];
  isForZalo: boolean | null;
  descriptionZalo: string | null;
  zaloNotificationAt: string | null;
  communityId: number | null;
  communityName: string | null;
  courseId: number | null;
  courseName: string | null;
  createdById: number | null;
  createdByName: string | null;
  totalSubmissions: number;
  submissionsByStatus: Partial<Record<SubmissionStatus, number>>;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface AssignmentSubmissionItem {
  id: number;
  userId: number | null;
  fullname: string | null;
  email: string | null;
  mobile: string | null;
  avatarUrl: string | null;
  status: SubmissionStatus | null;
  content: string | null;
  imageUrls: string[];
  pdfUrls: string[];
  videoUrls: string[];
  feedbackCount: number;
  submittedAt: string | null;
  updatedAt: string | null;
}

export interface AssignmentListParams {
  communityId?: number;
  page?: number;
  size?: number;
  sort?: string;
  search?: string;
  type?: AssignmentType;
  published?: boolean;
  courseId?: number;
}

export interface SubmissionListParams {
  status?: SubmissionStatus;
  page?: number;
  size?: number;
  sort?: string;
}
